import type { MaterialInfo, PartDefinition } from "@rogue/rackbuilder"
import { FMLBuilder } from "../fmlBuilder"
import {
  createFMLPulleysBase,
  createFMLPulleysWithShrouds,
  createFMLFrontSystem,
} from "./fmlParts"

// StandardFMLBuilder — Assembles FML-6 and FML-HR onto a power rack
export class StandardFMLBuilder extends FMLBuilder {

  // MARK: Side Meshes
  protected buildFMLSideMeshes(
    materials: MaterialInfo,
    left: boolean,
    isHalfRack: boolean
  ): PartDefinition[] {
    // Half rack: pulleys only — shrouds appended by buildFMLHalfRackExtraMeshes in base
    if (isHalfRack) {
      return [createFMLPulleysBase(materials, left)]
    }

    // Full rack: pulleys + optional shrouds
    return createFMLPulleysWithShrouds(this.createContext(materials), left)
  }

  // MARK: Front System (full rack only)
  protected buildFMLFrontSystem(
    materials: MaterialInfo,
    left: boolean,
    depth: string
  ): PartDefinition {
    return createFMLFrontSystem(
      { ...this.createContext(materials), depth },
      left,
      this.buildFMLBackShared(materials, left)
    )
  }

  // MARK: Extra Front Meshes (none for Standard)
  protected buildFMLExtraFrontMeshes(
    _materials: MaterialInfo,
    _left: boolean,
    _depth: string
  ): PartDefinition[] {
    return []
  }

  // MARK: Back Stabilizer Slots
  protected buildFMLBackStabilizerSlots(
    materials: MaterialInfo,
    left: boolean
  ): PartDefinition[] {
    if (!left) return []

    return [this.buildFMLLowRow(materials)]
  }
}
